import { z } from "zod";
import { BaseFilterInputSchema } from "../BaseFilterInput";
import { ReportDownloadTypeEnum, ReportDownloadTypeEnumSchema } from "@/Enums/ReportDownloadTypeEnum";

export const GetExecutedReportDataColumnFilterSchema = z.object({
    colName: z.string(),
    colFilteredValue: z.string(),
});

export type GetExecutedReportDataColumnFilter = z.infer<typeof GetExecutedReportDataColumnFilterSchema>;

export const GetExecutedReportDataInputSchema = BaseFilterInputSchema.extend({
    reportDownloadType: ReportDownloadTypeEnumSchema.default(ReportDownloadTypeEnum.DATA),
    reportHistoryId: z.string(),
    dataFilter: z.string().nullish().default(""),
    group: z.string().nullish(),
    generateFileIfNotExists: z.boolean().nullable().default(null),
    getDataAsList: z.boolean().nullable().default(null),
    columnFilters: z.array(GetExecutedReportDataColumnFilterSchema).nullable().default(null),
    userName: z.string().nullable().default(null),
});

export type GetExecutedReportDataInput = z.infer<typeof GetExecutedReportDataInputSchema>;